import PropTypes from "prop-types";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { INBOX_QUICK_FILTERS } from "@/lib/inboxChannels";

export function InboxToolbar({
  search,
  onSearchChange,
  activeFilter,
  onFilterChange,
  resultCount,
}) {
  return (
    <div className="shrink-0 border-b border-slate-100 bg-white px-3 py-2 space-y-2" data-testid="inbox-toolbar">
      <div className="relative">
        <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search conversations…"
          className="h-10 sm:h-8 pl-8 pr-8 text-[12.5px]"
          data-testid="inbox-search-input"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearchChange("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 h-8 w-8 inline-flex items-center justify-center"
            aria-label="Clear search"
          >
            <X size={14} />
          </button>
        )}
      </div>
      <div className="flex items-center gap-1 overflow-x-auto scrollbar-thin py-1 px-0.5 -mx-0.5">
        {INBOX_QUICK_FILTERS.map((f) => {
          const active = activeFilter === f.id;
          return (
            <button
              key={f.id}
              type="button"
              onClick={() => onFilterChange(f.id)}
              className={cn(
                "shrink-0 rounded-full px-2.5 py-1.5 sm:py-1 min-h-9 sm:min-h-0 text-[10.5px] font-medium ring-1 transition-colors",
                active
                  ? "bg-slate-800 text-white ring-slate-800"
                  : "bg-white text-slate-600 ring-slate-200 hover:bg-slate-50",
              )}
              data-testid={`inbox-filter-${f.id}`}
            >
              {f.label}
            </button>
          );
        })}
      </div>
      <div className="text-[10.5px] text-slate-500">
        {resultCount} conversation{resultCount === 1 ? "" : "s"}
      </div>
    </div>
  );
}

InboxToolbar.propTypes = {
  search: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  activeFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  resultCount: PropTypes.number.isRequired,
};
